import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';
import { APIService } from 'src/app/api/api.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard {
  constructor(private authService: AuthService, private apiService: APIService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.apiService.getAuth())
      return true;

    // not logged in so redirect to login page with the return url
    const url = new URL(window.location.href);
    const accessKey = url.searchParams.get('accesskey');

    if (accessKey) {
      const pathAndQuery = url.pathname + url.search;
      localStorage.setItem('redirectUrl', pathAndQuery);
    }

    this.authService.logout(accessKey?? undefined);
    return false;
  }
}
